import {type Module} from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

// state
const state: ModuleChatState = {
    lastUpdate: '',
    participantChats: [],
    strangerChats: [],

    isAdmin: false,

    showChat: false,
    activeTab: null,
    detailsOpen: false,
    activeChat: null,

    // messages
    totalUnreadMessages: 0,
    unreadChatsInfo: [],

    // last active Chat
    lastActiveChat: {
        name: '',
        imageSrc: '',
    },

    reply: null,
};

// module
const chat: Module<ModuleChatState, RootState> = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};

export default chat;